export const hasGuestBreakdown = (reservation) =>
  reservation?.adults_count != null && reservation?.children_count != null;

export const GuestBreakdown = ({ reservation, prefix }) => (
    hasGuestBreakdown(reservation) ? (
      <>
        <p data-testid={`${prefix}-adults-count`}>Erwachsene: {reservation.adults_count}</p>
        <p data-testid={`${prefix}-children-count`}>Kinder (0–12 Jahre): {reservation.children_count}</p>
      </>
    ) : <p data-testid={`${prefix}-legacy-guests`} className="text-sm">Aufteilung nicht erfasst</p>
);

export const GuestSummary = ({ reservation, prefix }) => (
  <div data-testid={`${prefix}-guest-summary`} className="min-w-0 break-words">
    <p data-testid={`${prefix}-guest-total`} className="font-semibold">Gäste gesamt: {reservation.guests_count}</p>
    <GuestBreakdown reservation={reservation} prefix={prefix} />
  </div>
);